import {
  ApiResponse,
  TradeInDiscountGrouped,
  CreateDiscount,
  TokenData,
  TradeInDiscount,
  OtpResponse,
  CreateDiscountLimits,
  CreateCampaignDiscountGroup,
  CampaignTradeInDiscount,
  CreateCampaignTradeInDiscountLimits,
} from '../models';
import * as http from './http';
import ApiService from './service';

export class CampaignTradeInDiscountService extends ApiService {
  public async loadTradeInDiscountType() {
    const url = `${this.apiDomain}/api/discount/tradeIn`;

    const resposne = await http.get<ApiResponse<TradeInDiscountGrouped>>(
      url,
      this.store
    );
    return resposne?.data?.data;
  }
  public async createDiscount(data: CreateCampaignDiscountGroup, id?: string) {
    const url = `${this.apiDomain}/api/campaign/${id}/add-discount`;

    const response = await http.post<ApiResponse<TokenData>>(
      url,
      { ...data, discountType: 'Trade_In_Discount' },
      this.store
    );
    return response.data;
  }

  public async updateDiscount(data: CreateCampaignDiscountGroup, id?: string) {
    const url = `${this.apiDomain}/api/campaign/${id}/update-add-discount`;

    const response = await http.post<ApiResponse<TokenData>>(
      url,
      { ...data, discountType: 'Trade_In_Discount' },
      this.store
    );
    return response.data;
  }

  public async getTradeInDiscount(id: string) {
    const url = `${this.apiDomain}/api/campaign/trade-in-discount/${id}`;

    const resposne = await http.get<ApiResponse<CampaignTradeInDiscount>>(
      url,
      this.store
    );
    return resposne?.data?.data;
  }

  public async requestOtp(purpose?: string) {
    const url = `${this.apiDomain}/api/otp/request`;

    const response = await http.post<ApiResponse<OtpResponse>>(
      url,
      {
        purpose: purpose || 'Confirm Discount Request',
      },
      this.store
    );
    return response.data;
  }
  public async reSendOtp(id?: string, purpose?: string) {
    const url = `${this.apiDomain}/api/otp/${id}/resend`;

    const response = await http.put<ApiResponse<OtpResponse>>(
      url,
      {
        purpose: purpose || 'Confirm Discount Request',
      },
      this.store
    );
    return response.data;
  }

  public async updateTradeInDiscountLimits(
    data?: CreateCampaignTradeInDiscountLimits,
    id?: string
  ) {
    const url = `${this.apiDomain}/api/campaign/edit/${id}/trade-in-discount`;

    const response = await http.put<ApiResponse<CampaignTradeInDiscount>>(
      url,
      data,
      this.store
    );
    return response.data;
  }
  public async cloneDiscount(data: CreateDiscount, id?: string) {
    const url = `${this.apiDomain}/api/discount/tradeIn/${id}/clone`;

    const response = await http.post<ApiResponse<TradeInDiscount>>(
      url,
      data,
      this.store
    );
    return response?.data?.data;
  }
  public async deleteDiscount(id?: string) {
    const url = `${this.apiDomain}/api/campaign/trade-in/${id}`;
    const response = await http.remove<ApiResponse<TokenData>>(url, this.store);
    return response.data;
  }
}
